import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { EncounterSummaryControllerApi } from "@/services";
import { EncounterSummaryReport } from "@/types/encounter-summary-report-types";
import { getConfigObject } from "@/utils/utils";

export const ENCOUNTER_SUMMARY_REPORT_QUERY_KEY = "encounter-summary-report";

interface Props {
  appointmentUuid?: string;
  sectionKeys?: string[];
  xTENANTID?: string;
  enabled?: boolean;
}

/** Snapshot plus sign-off report lines; `sectionKeys` limits the report to those sections. */
export const useEncounterSummaryReport = ({
  appointmentUuid,
  sectionKeys,
  xTENANTID,
  enabled = true,
}: Props): UseQueryResult<EncounterSummaryReport | undefined, AxiosError> =>
  useQuery({
    queryKey: [
      ENCOUNTER_SUMMARY_REPORT_QUERY_KEY,
      appointmentUuid,
      sectionKeys,
      xTENANTID,
    ],
    refetchOnWindowFocus: false,
    enabled: !!appointmentUuid && enabled,
    staleTime: 30_000,
    queryFn: async () =>
      new EncounterSummaryControllerApi(getConfigObject())
        .getEncounterSummaryReport(appointmentUuid!, sectionKeys, xTENANTID)
        .then((res) => res.data?.data as EncounterSummaryReport | undefined),
  });
